import { render } from "./DailyCollections.vue?vue&type=template&id=32388cdd&scoped=true"
import script from "./DailyCollections.vue?vue&type=script&lang=js"
export * from "./DailyCollections.vue?vue&type=script&lang=js"

import "./DailyCollections.vue?vue&type=style&index=0&id=32388cdd&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32388cdd"]])

export default __exports__